import React, { useState } from 'react';
import {
  Alert,
  Button,
  Card,
  CardContent,
  CardHeader,
  FormControl,
  FormControlLabel,
  InputLabel,
  MenuItem,
  Select,
  Stack,
  Switch,
} from '@mui/material';
import BackupRoundedIcon from '@mui/icons-material/BackupRounded';
import DownloadRoundedIcon from '@mui/icons-material/DownloadRounded';
import LockResetRoundedIcon from '@mui/icons-material/LockResetRounded';
import SaveRoundedIcon from '@mui/icons-material/SaveRounded';
import SecurityRoundedIcon from '@mui/icons-material/SecurityRounded';
import DashboardLayout from '../components/DashboardLayout';
import AdminActionGroup from '../components/AdminActionGroup';

const Settings = () => {
  const [emailNotifications, setEmailNotifications] = useState(true);
  const [darkMode, setDarkMode] = useState(false);
  const [defaultRole, setDefaultRole] = useState('Student');
  const [feedback, setFeedback] = useState('');

  const showAction = (message) => setFeedback(message);

  return (
    <DashboardLayout>
      <Stack spacing={2.5}>
        {feedback ? <Alert severity="success" onClose={() => setFeedback('')}>{feedback}</Alert> : null}

        <Card>
          <CardHeader title="General" subheader="Set defaults used when creating administrator-managed accounts." />
          <CardContent>
            <FormControl fullWidth sx={{ maxWidth: 420 }}>
              <InputLabel id="default-role-label">Default user role</InputLabel>
              <Select labelId="default-role-label" label="Default user role" value={defaultRole} onChange={(event) => setDefaultRole(event.target.value)}>
                {['Student', 'Instructor', 'Admin'].map((role) => <MenuItem key={role} value={role}>{role}</MenuItem>)}
              </Select>
            </FormControl>
          </CardContent>
        </Card>

        <Card>
          <CardHeader title="Preferences" subheader="Control personal interface and notification preferences." />
          <CardContent>
            <Stack>
              <FormControlLabel
                control={<Switch checked={emailNotifications} onChange={(event) => setEmailNotifications(event.target.checked)} />}
                label="Enable email notifications"
              />
              <FormControlLabel
                control={<Switch checked={darkMode} onChange={(event) => setDarkMode(event.target.checked)} />}
                label="Enable dark mode"
              />
            </Stack>
          </CardContent>
        </Card>

        <Card>
          <CardHeader title="Security" subheader="Manage administrator account security." />
          <CardContent>
            <AdminActionGroup>
              <Button variant="outlined" startIcon={<LockResetRoundedIcon />} onClick={() => showAction('Password reset link prepared.')}>Reset admin password</Button>
              <Button variant="outlined" startIcon={<SecurityRoundedIcon />} onClick={() => showAction('Two-factor authentication setup opened.')}>Set up two-factor authentication</Button>
            </AdminActionGroup>
          </CardContent>
        </Card>

        <Card>
          <CardHeader title="System" subheader="Run controlled maintenance and export actions." />
          <CardContent>
            <AdminActionGroup>
              <Button variant="outlined" startIcon={<DownloadRoundedIcon />} onClick={() => showAction('System log export prepared.')}>Download system logs</Button>
              <Button variant="outlined" startIcon={<BackupRoundedIcon />} onClick={() => showAction('Database backup request prepared.')}>Back up database</Button>
            </AdminActionGroup>
          </CardContent>
        </Card>

        <Button variant="contained" startIcon={<SaveRoundedIcon />} onClick={() => showAction('Settings saved.')} sx={{ alignSelf: 'flex-start' }}>
          Save settings
        </Button>
      </Stack>
    </DashboardLayout>
  );
};

export default Settings;
